import React from 'react';
import { CheckIcon, PhoneCallIcon, CalendarCheckIcon, MessageCircleIcon } from 'lucide-react';
import { Badge } from '../Badge';
import { Button } from '../Button';
function scrollToContact() {
  document.querySelector('#contact')?.scrollIntoView({
    behavior: 'smooth'
  });
}
const FEATURES: string[] = ['かかってきた電話に、AI受付スタッフがいつでも応対', '24時間365日、予約をそのまま受け付け', 'よくある問い合わせには、待たせず即座に回答', '取り次ぎや伝言もおまかせ。あなたは本業に集中'];
type Activity = {
  icon: React.ReactNode;
  label: string;
  text: string;
};
const ACTIVITY: Activity[] = [{
  icon: <PhoneCallIcon className="h-5 w-5" aria-hidden="true" data-id="element-270" />,
  label: '電話応対',
  text: '「お電話ありがとうございます。ご用件をお伺いします。」'
}, {
  icon: <CalendarCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-271" />,
  label: '予約受付',
  text: '木曜 14:00 のご予約を承りました。'
}, {
  icon: <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-272" />,
  label: '問い合わせ',
  text: '営業時間は平日 9:00〜18:00です。即時にご回答しました。'
}];
export function SolutionSection() {
  return <section id="ai-staff" className="w-full scroll-mt-24 bg-white" data-id="element-273">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 py-16 sm:px-6 sm:py-24 lg:grid-cols-2" data-id="element-274">
        {/* Copy column */}
        <div data-id="element-275">
          <Badge variant="sage" data-id="element-276">OptiDSA の AI受付スタッフ</Badge>
          <h2 className="mt-4 text-2xl font-bold leading-snug text-text sm:text-3xl" data-id="element-277">
            電話も予約も問い合わせも、
            <br className="hidden sm:block" data-id="element-278" />
            「AI受付スタッフ」におまかせ。
          </h2>
          <p className="mt-4 text-base leading-relaxed text-text-muted" data-id="element-279">
            むずかしい設定や操作は必要ありません。あなたの会社の“もう一人の受付担当”として、
            AI受付スタッフが日々の対応を引き受けます。起こることはシンプルです——
            電話に出られ、予約が入り、問い合わせに即答できる。それだけです。
          </p>

          <ul className="mt-8 space-y-3" data-id="element-280">
            {FEATURES.map(f => <li key={f} className="flex items-start gap-3" data-id="element-281">
                <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage-green/15 text-sage-green" data-id="element-282">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-283" />
                </span>
                <span className="text-base leading-relaxed text-text" data-id="element-284">{f}</span>
              </li>)}
          </ul>

          <div className="mt-10" data-id="element-285">
            <Button variant="primary" size="lg" onClick={scrollToContact} data-id="element-286">
              無料デモを体験する
            </Button>
          </div>
        </div>

        {/* Visual panel */}
        <div className="rounded-lg bg-deep-navy p-6 shadow-lg sm:p-8" aria-hidden="true" data-id="element-287">
          <div className="flex items-center gap-3 border-b border-white/15 pb-4" data-id="element-288">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-sky-blue/25 text-white" data-id="element-289">
              <PhoneCallIcon className="h-5 w-5" data-id="element-290" />
            </span>
            <div data-id="element-291">
              <p className="text-sm font-bold text-white" data-id="element-292">AI受付スタッフ</p>
              <p className="flex items-center gap-1.5 text-xs text-white/70" data-id="element-293">
                <span className="inline-block h-2 w-2 rounded-full bg-sage-green" data-id="element-294" />
                対応中・24時間オンライン
              </p>
            </div>
          </div>

          <div className="mt-6 space-y-4" data-id="element-295">
            {ACTIVITY.map(a => <div key={a.label} className="rounded-md bg-white/10 p-4" data-id="element-296">
                <div className="flex items-center gap-2 text-sky-blue" data-id="element-297">
                  {a.icon}
                  <span className="text-xs font-semibold uppercase tracking-wide" data-id="element-298">
                    {a.label}
                  </span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-white/90" data-id="element-299">
                  {a.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}